import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import AssetReport from "../../../containers/modules/report/asset-report";

export default function AssetReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="asset-report"
      index
      element={
        <AccessControl
          name={"Asset Report Show"}
          auth={authUser}
          component={() => <AssetReport />}
        />
      }
    ></Route>
  );
}
